import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = null

export default handleActions(
  {
    [rawActions.setAiObjectToDelete](state, action) {
      return action.payload
    },
    [rawActions.deleteAiObject.request](state, action) {
      return null
    },
    [rawActions.resetState](state, payload) {
      return defaultState
    },
  },
  defaultState
)
